import React from 'react';

function SuccessSVG(props) {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox={props.viewbox}
      className={props.classes}
    >
      <title>Icon / Large / Success</title>
      <path
        fill={props.fill}
        d="M70,35 C70,41.3037642 68.4240584,47.1370968 65.2721774,52.5 C62.1202964,57.8629032 57.8629032,62.1202964 52.5,65.2721774 C47.1370968,68.4240584 41.3037642,70 35,70 C28.6962358,70 22.8629032,68.4240584 17.5,65.2721774 C12.1370968,62.1202964 7.87970358,57.8629032 4.72782258,52.5 C1.57594158,47.1370968 0,41.3037642 0,35 C0,28.6962358 1.57594158,22.8629032 4.72782258,17.5 C7.87970358,12.1370968 12.1370968,7.87970358 17.5,4.72782258 C22.8629032,1.57594158 28.6962358,0 35,0 C41.3037642,0 47.1370968,1.57594158 52.5,4.72782258 C57.8629032,7.87970358 62.1202964,12.1370968 65.2721774,17.5 C68.4240584,22.8629032 70,28.6962358 70,35 Z M31.421875,54.2887029 L57.296875,28.1129707 C57.7656243,27.7336115 58,27.2119951 58,26.5481172 C58,25.8842392 57.7656243,25.3626228 57.296875,24.9832636 L54.203125,21.7112971 C53.7343757,21.2370997 53.1953118,21 52.5859375,21 C51.9765632,21 51.4374993,21.2370997 50.96875,21.7112971 L29.875,43.0502092 L20.03125,33.0920502 C19.5625007,32.6178529 19.0234368,32.3807531 18.4140625,32.3807531 C17.8046882,32.3807531 17.2656243,32.6178529 16.796875,33.0920502 L13.703125,36.3640167 C13.2343757,36.7433759 13,37.2649923 13,37.9288703 C13,38.5927483 13.2343757,39.1143647 13.703125,39.4937238 L28.328125,54.2887029 C28.7031257,54.7629003 29.2187493,55 29.875,55 C30.5312507,55 31.0468743,54.7629003 31.421875,54.2887029 Z"
        id="check-circle"
      ></path>
    </svg>
  );
}

export default SuccessSVG;
